/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/date_unit_count.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Counts how many `to_unit` values are contained in a single `from_unit` period for `date`.',
  examples: [
    'ROW dt = to_datetime("2024-02-15T00:00:00.000Z")\n| EVAL days = DATE_UNIT_COUNT("day", "month", dt)',
  ],
  params: {
    to_unit: 'The unit to count.',
    from_unit: 'The enclosing container unit.',
    date: 'Date expression.',
  },
};

export default docs;
